import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Icons from "../../Assets/Icons"
import "./confirmModal.css";
import { useNavigate } from "react-router-dom";
import strings from "../../utils/strings";

const ConfirmModal = ({ showModal, handleCancel, handleConfirm, heading, description, postive, reject }) => {
  const { t } = useTranslation();
  const nav=useNavigate()
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (showModal) {
      setVisible(true);
    }
  }, [showModal]);

  const handleCloseWithTransition = (callback) => {
    setVisible(false);
    setTimeout(() => {
      callback();
    }, 300);
  };

  if (!showModal && !visible) return null;
  return (
    <div className="modal-overlay-del">
      <div className={`modal-content-del ${visible ? "modal-open" : "modal-close"}`}>
      {heading === "tncWarningHead" && <img src={Icons.cross} className="cross-icon-modal" onClick={() => handleCloseWithTransition(handleCancel)}/>}
        <div className="modal-header-del">
          <h2>{t(heading)}</h2>
        </div>
        <div className="modal-body-del">
          <p>{t(description)}</p>
        </div>
        <div className="modal-footer-del">
          <button className={`modal-cancel-button ${reject ? "reject" : ""}`} onClick={() => {heading === "tncWarningHead" ? nav(strings.navigation.termsCondition) :handleCloseWithTransition(handleCancel)}}>
            {reject ? t("reject") :heading === "tncWarningHead"?t("discard") :t("cancel")}
            {/* {t("cancel")} */}
          </button>
          {/* <button className="modal-confirm-button" onClick={() => handleCloseWithTransition(handleConfirm)}>{t("confirm")}</button> */}
          <button className={`${postive ? "positive" : ""} modal-confirm-button`} onClick={() => handleCloseWithTransition(handleConfirm)}>
            {heading === "tncWarningHead"?t("save"):t("confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
